// This file has nothing to do with redux actions.
// Provides a definition for common application actions that abstract away from key event inputs.
const moveUp = 'moveUp';
const moveDown = 'moveDown';
const moveLeft = 'moveLeft';
const moveRight = 'moveRight';
const select = 'select';
const back = 'back';
const fastForward = 'fastForward';
const rewind = 'rewind';
const skipForward = 'skipForward';
const skipBackward = 'skipBackward';
const play = 'play';
const pause = 'pause';
const playPause = 'playPause';

const isMovementAction = (action: string): boolean => !!(action && action.startsWith('move'));

export default {
  moveUp,
  moveDown,
  moveLeft,
  moveRight,
  select,
  selectReleased: 'selectReleased',
  play,
  pause,
  playPause,
  fastForward,
  rewind,
  seek: 'seek',
  stop: 'stop',
  nextTrack: 'nextTrack',
  prevTrack: 'prevTack',

  back,
  menu: 'menu',
  exit: 'exit',
  search: 'search',
  delete: 'delete',
  captions: 'captions',

  // Present on some remotes, e.g. LG
  red: 'red',
  green: 'green',
  yellow: 'yellow',
  blue: 'blue',

  extra: 'extra', // on Tizen 2016 remote
  cancel: 'cancel', // Samsung keyboard/IEM key

  num1: '1',
  num2: '2',
  num3: '3',
  num4: '4',
  num5: '5',
  num6: '6',
  num7: '7',
  num8: '8',
  num9: '9',
  num0: '0',

  // Playstation controller
  buttonX: 'buttonX', // also XBox, and for that matter Nintendo, but with a different meaning
  buttonSquare: 'buttonSquare',
  buttonCircle: 'buttonCircle',
  buttonTriangle: 'buttonTriangle',

  // Xbox controller
  buttonA: 'buttonA',
  buttonB: 'buttonB',
  buttonY: 'buttonY',

  // Common console shoulder buttons
  leftShoulder1: 'leftShoulder1',
  leftShoulder2: 'leftShoulder2',
  rightShoulder1: 'rightShoulder1',
  rightShoulder2: 'rightShoulder2',
  leftStick: 'leftStick', // i.e. the "click" of pressing down on the stick
  rightStick: 'rightStick',

  // Common console Media remote actions
  skipForward,
  skipBackward,
  info: 'info',

  longPressStart: 'longPressStart',
  longPressEnd: 'longPressEnd',

  isMovementAction,

  isUpDownAction: (action: string): boolean => action === moveUp || action === moveDown,

  isLeftRightAction: (action: string): boolean => action === moveLeft || action === moveRight,

  // Movement, select, and back actions are fundamental to navigation
  isCoreAction: (action: string): boolean =>
    isMovementAction(action) || action === select || action === back,

  isSeekAction: (action: string): boolean =>
    action === fastForward ||
    action === rewind ||
    action === skipForward ||
    action === skipBackward,

  isPlayPauseAction: (action: string): boolean =>
    action === play || action === pause || action === playPause,
};
